;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="94d228aa-47a4-4b76-85fc-d6556618f11f",e._sentryDebugIdIdentifier="sentry-dbid-94d228aa-47a4-4b76-85fc-d6556618f11f")}catch(e){}}();import React__default from 'react';
import styles from './BrandLogo.module.scss.js';
import '../../_virtual/_sentry-release-injection-file.js';

const BrandLogo = ({ id, mediaServerURL, bundle, brand, alt, }) => {
    const logoBaseUrl = `${mediaServerURL}/images/${bundle}/logo/${brand}`;
    return (React__default.createElement("a", { className: styles.logoWrapper, href: "/" },
        React__default.createElement("img", { className: styles.logoImg, "data-zta": "brand_logo", id: id, src: `${logoBaseUrl}.png`, srcSet: `${logoBaseUrl}.png 1x, ${logoBaseUrl}@2x.png 2x`, alt: alt })));
};

export { BrandLogo as default };
//# sourceMappingURL=BrandLogo.js.map
